import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import RectButton from "../../components/ui/button/RectButton";

import { ReactComponent as FacebookIc } from '../../components/assets/icons/facebook-ic.svg';
import { ReactComponent as TwitterIc } from '../../components/assets/icons/twitter-ic.svg';
import { ReactComponent as LinkedinIc } from '../../components/assets/icons/linkedin-ic.svg';
import { ReactComponent as InstagramIc } from '../../components/assets/icons/instagram-ic.svg';
import { ReactComponent as PinterestIc } from '../../components/assets/icons/pinterest-ic.svg';
import UsaStamp from '../../components/assets/images/usa-stamp.png';

import * as robotArmDataD from '../../components/assets/json/lottie/on-its-way-desktop.json'
import * as robotArmDataM from '../../components/assets/json/lottie/on-its-way-mobile.json'

import "./style.scss";
import ThanksFor from "../ThanksFor";

class OnItsWay extends Component {
    render() {
        return (
            <>
                <ThanksFor className="on-its-way" robotArmDataD={robotArmDataD} robotArmDataM={robotArmDataM}>
                    <h1 style={{visibility:'hidden'}}><span>Congrats!</span><span>Your order is on it’s way.</span></h1>
                    <p>Our robots are hard at work Handwryting your card. It will stamped and mailed with a confirmation email to you when it’s done.</p>
                    <Link className="action-bt" to="/"><RectButton text="Send More Cards" /></Link>
                    <div className="social row lock">
                        <FacebookIc />
                        <TwitterIc />
                        <LinkedinIc />
                        <InstagramIc />
                        <PinterestIc />
                    </div>
                    <div className="card-image"><img src={UsaStamp} alt="Card" /></div>
                </ThanksFor>
            </>
        )
    }
}

export default withRouter(OnItsWay);